export const infoWidgetList = ["resume", "submission", "interview", "selected"];

export const commonWidgetContent = {
  currentTitle: "My Contribution",
  avgTitle: `Company's Average`,
  highestTitle: "Top Performer",
  defaultImg: `${process.env.PUBLIC_URL + "/assests/TotalContributed.svg"}`,
};

export const widgetTypes = [
  {
    w: 6,
    h: 4,
    type: "barChart",
    title: "Candidate Status Distribution",
    description:
      "Track how resumes progress through the hiring journey—this bar chart shows candidates count grouped by status.",
    sampleImg: `${process.env.PUBLIC_URL}/assests/dashboard/BarChart.svg`,
    imageIcon: `${process.env.PUBLIC_URL + "/assests/BarChart-Icon.svg"}`,
  },
  {
    w: 3,
    h: 6,
    type: "TotalUploadedResumes",
    title: "Individual Performance by Resume Upload",
    config: commonWidgetContent,
    description:
      "Measure my contribution, compare it with team's and top performer contribution—track candidate contributions by resumes uploaded with a clear progress bar.",
    sampleImg: `${process.env.PUBLIC_URL}/assests/dashboard/ResumeContributed.svg`,
    imageIcon: `${process.env.PUBLIC_URL}/assests/cardIcon.svg`,
  },
  {
    w: 3,
    h: 6,
    type: "ResumeCount",
    title: "Individual Performance Tracker",
    config: commonWidgetContent,
    showStatus: true,
    description:
      "Measure my contribution, compare it with team's and top performer contribution—track candidate contributions across one or multiple statuses with a clear progress bar.",
    sampleImg: `${process.env.PUBLIC_URL}/assests/dashboard/ResumeContributed.svg`,
    imageIcon: `${process.env.PUBLIC_URL}/assests/cardIcon.svg`,
  },
  {
    w: 6,
    h: 4,
    type: "requirementsWidget",
    title: "Requirements Tracker",
    description:
      "Stay on top of hiring needs—see requirements sorted by date and filter between your submissions or the entire team’s.",
    sampleImg: `${process.env.PUBLIC_URL}/assests/dashboard/Table.svg`,
    imageIcon: `${process.env.PUBLIC_URL}/assests/Table-Icon.svg`,
  },
  {
    w: 6,
    h: 4,
    type: "pieChart",
    title: "Resume Upload Sources",
    description:
      "See where resumes are coming from—this pie chart breaks down uploads by source for quick insights.",
    sampleImg: `${process.env.PUBLIC_URL}/assests/dashboard/PieChart.svg`,
    imageIcon: `${process.env.PUBLIC_URL}/assests/PieChart-Icon.svg`,
  },
  {
    w: 6,
    h: 4,
    type: "GraphofStatus",
    title: "Status-wise Candidate Distribution",
    showStatus: true,
    description:
      "Visualize candidate volume across different statuses—choose the statuses you want, and see the counts in a clear bar graph.",
    sampleImg: `${process.env.PUBLIC_URL}/assests/dashboard/GroupOfStatus.svg`,
    imageIcon: `${process.env.PUBLIC_URL}/assests/BarChart-Icon.svg`,
  },
];

export const additionalWidgetTypes = [
  {
    w: 6,
    h: 4,
    type: "candidateDetailsByStatus",
    title: "Candidate Details By Status",
    description:
      "Shows candidates filtered by selected status and clients(optional) allowing users to quickly view and manage candidates in a specific stage of the hiring process.",
    sampleImg: `${process.env.PUBLIC_URL}/assests/dashboard/Table.svg`,
    imageIcon: `${process.env.PUBLIC_URL}/assests/Table-Icon.svg`,

    showClients: true,
    showCadidateStatus: true,
  },
  {
    w: 6,
    h: 4,
    type: "GraphbyClient",
    title: "Client-Wise Candidate Status",
    showStatus: true,
    showClient: true,
    description:
      "Track candidate outcomes for each client in a pie chart. Data is region-agnostic, giving you a unified view even when the same client spans multiple regions.",
    sampleImg: `${process.env.PUBLIC_URL}/assests/dashboard/GroupByClients.svg`,
    imageIcon: `${process.env.PUBLIC_URL}/assests/PieChart-Icon.svg`,
  },
  {
    w: 6,
    h: 4,
    type: "JobStatusByClient",
    title: "Client-Wise Job Status",
    showJobStatus: true,
    showClients: true,
    description:
      "Track Job Status for each client in a pie chart. Data is region-agnostic, giving you a unified view even when the same client spans multiple regions.",
    sampleImg: `${process.env.PUBLIC_URL}/assests/dashboard/GroupByClients.svg`,
    imageIcon: `${process.env.PUBLIC_URL}/assests/PieChart-Icon.svg`,
  },
  {
    w: 6,
    h: 4,
    type: "DeliveryOutcomeByClients",
    title: "Delivery Outcome by Clients vs. Candidate Status",
    description:
      "See how each client account is performing—track candidate outcomes by status to measure delivery success.",
    sampleImg: `${process.env.PUBLIC_URL}/assests/img/MultiPerformanceStatus.svg`,
    imageIcon: `${process.env.PUBLIC_URL}/assests/BarGraph-Icon.svg`,
    showClients: true,
    showCadidateStatus: true,
  },
  {
    w: 6,
    h: 4,
    type: "RecruiterContributionByStatus",
    title: "Recruiter's Contribution by Status",
    description:
      "Compare how different recruiters perform by tracking the status of the candidates they’ve submitted.",
    sampleImg: `${process.env.PUBLIC_URL}/assests/img/RecruiterContribution.svg`,
    imageIcon: `${process.env.PUBLIC_URL}/assests/BarGraph-Icon.svg`,
    showRecruiter: true,
    showCadidateStatus: true,
  },
  {
    w: 6,
    h: 4,
    type: "GraphbyRecruiter",
    title: "Total resumes uploaded by recruiters",
    description:
      "View each recruiter’s impact by tracking the total profiles they’ve uploaded into the ATS.",
    sampleImg: `${process.env.PUBLIC_URL}/assests/img/GraphbyRecruiter.svg`,
    imageIcon: `${process.env.PUBLIC_URL}/assests/BarGraph-Icon.svg`,
    showRecruiterOnly: true,
  },
];

export const initialLayoutConfig = [
  {
    i: "1",
    x: 0,
    y: 0,
    w: 3,
    h: 6,
    type: "resume",
    title: "Total Resume Contributed",
    className: "dashboard__grid-item",
  },
  {
    i: "2",
    x: 3,
    y: 0,
    w: 3,
    h: 6,
    type: "submission",
    title: "Total Submissions",
    className: "dashboard__grid-item",
  },
  {
    i: "3",
    x: 6,
    y: 0,
    w: 3,
    h: 6,
    type: "interview",
    title: "Total Profiles in Interview",
    className: "dashboard__grid-item",
  },
  {
    i: "4",
    x: 9,
    y: 0,
    w: 3,
    h: 6,
    type: "selected",
    title: "Total Profiles Selected",
    className: "dashboard__grid-item",
  },
  {
    i: "5",
    x: 0,
    y: 7,
    w: 6,
    h: 4,
    type: "pieChart",
    title: "Candidates Grouped By Resume source", //need to change title later
    className: "dashboard__grid-item",
  },
  {
    i: "6",
    x: 0,
    y: 11,
    w: 6,
    h: 4,
    type: "barChart",
    title: "Candidates Grouped By Status (All Status)", //need to change title later
    className: "dashboard__grid-item",
  },
  {
    i: "7",
    x: 6,
    y: 7,
    w: 6,
    h: 4,
    type: "requirementsWidget",
    title: "List of Requirements Assigned", //need to change title later
    className: "requirement-widget dashboard__grid-item",
  },
];

export const widgetsMockData = [
  {
    i: "1",
    type: "resume",
    title: "Total Resume Contributed",
    currentValue: 0,
    currentTitle: "My Contribution",
    avgValue: 0,
    avgPercentage: 0,
    avgTitle: `Company's Average`,
    highestValue: "0",
    highestPercentage: 100,
    highestTitle: "Top Performer",
    img: `${process.env.PUBLIC_URL + "/assests/TotalContributed.svg"}`,
  },
  {
    i: "2",
    type: "submission",
    title: "Total Submissions",
    currentValue: 0,
    currentTitle: "My Contribution",
    avgValue: 0,
    avgPercentage: 0,
    avgTitle: `Company's Average`,
    highestValue: "0",
    highestPercentage: 100,
    highestTitle: "Top Performer",
    img: `${process.env.PUBLIC_URL + "/assests/TotalSubmissions.svg"}`,
  },
  {
    i: "3",
    type: "interview",
    title: "Total Profiles in Interview",
    currentValue: 0,
    currentTitle: "My Contribution",
    avgValue: 0,
    avgPercentage: 0,
    avgTitle: `Company's Average`,
    highestValue: "0",
    highestPercentage: 100,
    highestTitle: "Top Performer",
    img: `${process.env.PUBLIC_URL + "/assests/TotalInterview.svg"}`,
  },
  {
    i: "4",
    type: "selected",
    title: "Total Profiles Selected",
    currentValue: 0,
    currentTitle: "My Contribution",
    avgValue: 0,
    avgTitle: `Company's Average`,
    highestValue: "0",
    avgPercentage: 0,
    highestPercentage: 100,
    highestTitle: "Top Performer",
    img: `${process.env.PUBLIC_URL + "/assests/TotalSelected.svg"}`,
  },
  {
    i: "5",
    type: "pieChart",
    title: "Breakdown of Source of Resumes",
    data: [],
  },
  {
    i: "6",
    type: "barChart",
    title: "Total Resumes Uploaded vs Status",
    data: [],
  },
  {
    i: "7",
    type: "requirementsWidget",
    title: "List of Requirements Assigned to Recruiters",
    data: [],
  },
];

export const postingColumnData = [
  {
    id: 1,
    displayName: "Job Code",
    type: "Job Code",
    mappingName: "jobCode",
    theadClass: "dynatableheadtext text-center",
    tbodyClass: "dynatablebodytext text-center ",
    width: "150px",
    isEdit: true,
    nagigate: "countrywithflag",
  },
  {
    id: 2,
    displayName: "Job Title",
    type: "Job Code",
    mappingName: "jobTitle",
    theadClass: "dynatableheadtext text-center ",
    tbodyClass: "dynatablebodytext text-center NameCapitalise",
    width: "300px",
    isEdit: true,
    nagigate: "detailspage",
  },
  {
    id: 3,
    displayName: "Location",
    type: "Job Code",
    mappingName: "location",
    theadClass: "dynatableheadtext text-center",
    tbodyClass: "dynatablebodytext text-center NameCapitalise",
    width: "200px",
    isEdit: true,
    nagigate: "detailspage",
  },
  {
    id: 4,
    displayName: "Job Status",
    type: "Job Code",
    mappingName: "jobStatus",
    theadClass: "dynatableheadtext text-center",
    tbodyClass: "dynatablebodytext text-center",
    width: "120px",
    isEdit: true,
    nagigate: "detailspage",
  },
  {
    id: 5,
    displayName: "Client",
    type: "Job Code",
    mappingName: "clientName",
    theadClass: "dynatableheadtext text-center",
    tbodyClass: "dynatablebodytext text-center",
    width: "200px",
    isEdit: true,
    nagigate: "detailspage",
  },
];

export const applicantColumnData = [
  {
    id: 1,
    displayName: "Applicant Name",
    type: "Job Code",
    mappingName: "fullName",
    theadClass: "dynatableheadtext text-center",
    tbodyClass: "dynatablebodytext text-center ",
    width: "150px",
    isEdit: true,
    nagigate: "/ats/layout/applicants/view",
  },
  {
    id: 2,
    displayName: "Job Title",
    type: "Job Code",
    mappingName: "jobTitle",
    theadClass: "dynatableheadtext text-center",
    tbodyClass: "dynatablebodytext text-center NameCapitalise",
    width: "200px",
    isEdit: true,
    nagigate: "/ats/layout/applicants/view",
  },
  {
    id: 3,
    displayName: "Last Updated",
    type: "Job Code",
    mappingName: "updatedDate",
    theadClass: "dynatableheadtext text-center ",
    tbodyClass: "dynatablebodytext text-center NameCapitalise",
    width: "300px",
    isEdit: true,
    nagigate: "/ats/layout/applicants/view",
  },
  {
    id: 4,
    displayName: "Recruiter Name",
    type: "Job Code",
    mappingName: "recruiterName",
    theadClass: "dynatableheadtext text-center",
    tbodyClass: "dynatablebodytext text-center",
    width: "120px",
    isEdit: true,
    nagigate: "/ats/layout/applicants/view",
  },
  {
    id: 5,
    displayName: "Client",
    type: "Job Code",
    mappingName: "clientName",
    theadClass: "dynatableheadtext text-center",
    tbodyClass: "dynatablebodytext text-center",
    width: "200px",
    isEdit: true,
    nagigate: "/ats/layout/applicants/view",
  },
  {
    id: 6,
    displayName: "Status",
    type: "Job Code",
    mappingName: "status",
    theadClass: "dynatableheadtext text-center",
    tbodyClass: "dynatablebodytext text-center font-weight-bold",
    width: "200px",
    isEdit: true,
    nagigate: "/ats/layout/applicants/view",
  },
];

export const configuration = {
  isSearchbar: false,
  isPaging: false,
  isDropdownActions: false,
  isCheckbox: false,
  isActions: false,
  recordperPage: 10,
  currentPage: 1,
  totalRecords: 0,
  isTotalCount: false,
  totalRecordsCount: 0,
  totalRecordsCountText: "",
  limitData: 20,
  isCheckAlignRight: true,
  isPaginationTop: true,
  isSearchServer: false,
  isPagingServer: false,
  isPageRange: false,
};

export const disabled_Configured_Card = [
  "resume",
  "submission",
  "interview",
  "selected",
];
